import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';

export interface InvoicingDemoResetConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    onConfirm: () => void;
}

const InvoicingDemoResetConfirmModal = ({
    isOpen,
    onClose,
    isLoading,
    onConfirm,
}: InvoicingDemoResetConfirmModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    Reset demo invoicing data?
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.600">
                        This will replace all Invoicing Demo Org invoices and related processing
                        data with the frozen golden snapshot from production. Any uploads or edits
                        made since that snapshot will be lost.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="sm" variant="outline" onClick={onClose} isDisabled={isLoading}>
                            Cancel
                        </Button>
                        <Button
                            size="sm"
                            colorScheme="orange"
                            onClick={onConfirm}
                            isLoading={isLoading}
                            loadingText="Resetting..."
                        >
                            Reset
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoicingDemoResetConfirmModal;
